
<div class="cp-loading">
  <div class="container">
    <div class="ball" />
    <div class="ball ball-1" />
  </div>
</div>
